import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaConciergeBell, FaMoneyBillAlt, FaUtensils } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function OrderFood() {
  const [foodItems, setFoodItems] = useState([
    {
      id: 1,
      name: 'Burger',
      description: 'Delicious chicken burger',
      price: 10,
      image:
        'https://www.foodandwine.com/thmb/DI29Houjc_ccAtFKly0BbVsusHc=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/crispy-comte-cheesburgers-FT-RECIPE0921-6166c6552b7148e8a8561f7765ddf20b.jpg',
      status: 'Available',
    },
    {
      id: 2,
      name: 'Pizza',
      description: 'Cheesy pepperoni pizza',
      price: 15,
      image:
        'https://www.allrecipes.com/thmb/9UTj7kZBJDqory0cdEv_bw6Ef_0=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/48727-Mikes-homemade-pizza-DDMFS-beauty-2x1-BG-2976-d5926c9253d3486bbb8a985172604291.jpg',
      status: 'Available',
    },
    {
      id: 3,
      name: 'Veg Thali',
      description: 'Kokan Special Veg Thali',
      price: 500,
      image:
        'https://images.squarespace-cdn.com/content/v1/612d4825ee7c3b7ba3e215b7/1667458982443-N6XGU1PU7335QEMVUP7M/Delicious+food.png',
      status: 'Available',
    },
    {
      id: 4,
      name: 'Dosa',
      description: 'Special Dosa',
      price: 250,
      image:
        'https://photos.smugmug.com/Asia/India/i-Pf4hCQr/0/d3d38770/X2/indian-food-dosa-X2.jpg',
      status: 'Not Available',
    },
    {
      id: 5,
      name: 'Butter Chicken',
      description: 'Rich and creamy chicken curry',
      price: 300,
      image: 'https://masalaandchai.com/wp-content/uploads/2022/03/Butter-Chicken-500x375.jpg',
      status: 'Available',
    },
    {
      id: 6,
      name: 'Biryani',
      description: 'Fragrant rice dish with meat or vegetables',
      price: 350,
      image:
        'https://static.wixstatic.com/media/c47167_4e575594ceab4c95b6d3ad001890c0c7~mv2.webp/v1/fill/w_568,h_378,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/c47167_4e575594ceab4c95b6d3ad001890c0c7~mv2.webp',
      status: 'Available',
    },
  ]);

  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const [newFoodItem, setNewFoodItem] = useState({
    name: '',
    description: '',
    price: '',
    image: '',
    status: 'Available',
  });

  const [editingFoodItem, setEditingFoodItem] = useState(null);
  const [deleteFoodId, setDeleteFoodId] = useState(null);

  // Add new food item
  const handleAddFoodItem = () => {
    if (newFoodItem.name && newFoodItem.description && newFoodItem.price && newFoodItem.image) {
      const newItem = {
        ...newFoodItem,
        id: foodItems.length + 1,
        price: parseFloat(newFoodItem.price),
      };
      setFoodItems([...foodItems, newItem]);
      setShowAddPopup(false);
      setNewFoodItem({
        name: '',
        description: '',
        price: '',
        image: '',
        status: 'Available',
      });
      toast.success('Food item added successfully!');
    } else {
      toast.error('Please fill in all fields.');
    }
  };

  // Edit food item
  const handleEditFoodItem = () => {
    setFoodItems(
      foodItems.map((item) => (item.id === editingFoodItem.id ? { ...editingFoodItem } : item))
    );
    setShowEditPopup(false);
    setEditingFoodItem(null);
    toast.success('Food item updated successfully!');
  };

  // Delete food item
  const handleDeleteFoodItem = () => {
    setFoodItems(foodItems.filter((item) => item.id !== deleteFoodId));
    setShowDeletePopup(false);
    toast.success('Food item deleted successfully!');
  };

  return (
    <div className="flex h-full">
      {/* Sidebar */}
      <div className="w-1/4 bg-gray-100 text-black p-4 text-base font-semibold">
        <ul className="space-y-4 mt-4">
          <li className="hover:bg-gray-200 p-2 rounded flex items-center space-x-2">
            <FaConciergeBell className="text-lg" />
            <Link to="/dashboard/mdm/amenities-management/room-service">Room Service</Link>
          </li>
          <li className="hover:bg-gray-200 p-2 rounded flex items-center space-x-2">
            <FaMoneyBillAlt className="text-lg" />
            <Link to="/dashboard/mdm/amenities-management/amenities">Amenities</Link>
          </li>
          <li className=" bg-black text-white p-2 rounded flex items-center space-x-2">
            <FaUtensils className="text-lg" />
            <Link to="/dashboard/mdm/amenities-management/food-service">Food</Link>
          </li>
        </ul>
      </div>

      {/* Content Area */}
      <div className="ml-1 p-6 w-full bg-white">
        <h1 className="text-2xl font-bold">Food Management</h1>
        <p className="text-sm">
          Manage your hotel amenities such as meals, housekeeping, paid amenities, and room service
          requests here.
        </p>
        <div className="mt-4 flex justify-end">
          <button
            onClick={() => setShowAddPopup(true)}
            className="px-4 py-2 bg-cyan-500 text-white hover:text-black rounded"
          >
            Add Food Item
          </button>
        </div>

        {/* Food Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {foodItems.map((item) => (
            <div
              key={item.id}
              className="border border-gray-200 rounded-lg overflow-hidden shadow-lg bg-white flex flex-col items-center  "
            >
              <img src={item.image} alt={item.name} className="w-full h-56 object-fill mb-2 " />
              <div className="p-4 text-center">
                <h2 className="text-xl text-gray-800 font-semibold">{item.name}</h2>
                <p className="text-sm text-gray-500 mt-2">{item.description}</p>
                <p className="font-bold text-gray-900 mt-2">${item.price}</p>
                <p
                  className={`mt-2 ${
                    item.status === 'Available' ? 'text-green-500' : 'text-red-500'
                  } font-medium`}
                >
                  {item.status}
                </p>
              </div>
              <div className="flex justify-end gap-2 w-full p-4  mt-auto">
                <button
                  onClick={() => {
                    setEditingFoodItem(item);
                    setShowEditPopup(true);
                  }}
                  className="bg-cyan-500 px-7 rounded-md py-1 text-white hover:text-black"
                >
                  Edit
                </button>
                <button
                  onClick={() => {
                    setDeleteFoodId(item.id);
                    setShowDeletePopup(true);
                  }}
                  className="bg-red-500 px-4 rounded-md py-1 text-white hover:text-black"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Toast Notifications */}
        <ToastContainer />

        {/* Add Food Item Popup */}
        {showAddPopup && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10">
            <div className="bg-white p-6 rounded-lg w-1/3">
              <h2 className="text-xl font-semibold mb-4">Add Food Item</h2>
              <label className="block text-sm font-semibold mb-2">Food Name</label>
              <input
                type="text"
                value={newFoodItem.name}
                onChange={(e) => setNewFoodItem({ ...newFoodItem, name: e.target.value })}
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Description</label>
              <textarea
                value={newFoodItem.description}
                onChange={(e) =>
                  setNewFoodItem({
                    ...newFoodItem,
                    description: e.target.value,
                  })
                }
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Price ($)</label>
              <input
                type="number"
                value={newFoodItem.price}
                onChange={(e) => setNewFoodItem({ ...newFoodItem, price: e.target.value })}
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Image URL</label>
              <input
                type="text"
                value={newFoodItem.image}
                onChange={(e) => setNewFoodItem({ ...newFoodItem, image: e.target.value })}
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Status</label>
              <select
                value={newFoodItem.status}
                onChange={(e) => setNewFoodItem({ ...newFoodItem, status: e.target.value })}
                className="p-2 border rounded w-full mb-4"
              >
                <option value="Available">Available</option>
                <option value="Not Available">Not Available</option>
              </select>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={handleAddFoodItem}
                  className="px-4 py-2 bg-cyan-500 text-white rounded"
                >
                  Add
                </button>
                <button
                  onClick={() => setShowAddPopup(false)}
                  className="px-4 py-2 bg-red-500 text-white rounded ml-2"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Food Item Popup */}
        {showEditPopup && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10">
            <div className="bg-white p-6 rounded-lg w-1/3">
              <h2 className="text-xl font-semibold mb-4">Edit Food Item</h2>
              <label className="block text-sm font-semibold mb-2">Food Name</label>
              <input
                type="text"
                value={editingFoodItem?.name || ''}
                onChange={(e) =>
                  setEditingFoodItem({
                    ...editingFoodItem,
                    name: e.target.value,
                  })
                }
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Description</label>
              <textarea
                value={editingFoodItem?.description || ''}
                onChange={(e) =>
                  setEditingFoodItem({
                    ...editingFoodItem,
                    description: e.target.value,
                  })
                }
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Price ($)</label>
              <input
                type="number"
                value={editingFoodItem?.price || ''}
                onChange={(e) =>
                  setEditingFoodItem({
                    ...editingFoodItem,
                    price: parseFloat(e.target.value),
                  })
                }
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Image URL</label>
              <input
                type="text"
                value={editingFoodItem?.image || ''}
                onChange={(e) =>
                  setEditingFoodItem({
                    ...editingFoodItem,
                    image: e.target.value,
                  })
                }
                className="p-2 border rounded w-full mb-4"
              />
              <label className="block text-sm font-semibold mb-2">Status</label>
              <select
                value={editingFoodItem?.status || ''}
                onChange={(e) =>
                  setEditingFoodItem({
                    ...editingFoodItem,
                    status: e.target.value,
                  })
                }
                className="p-2 border rounded w-full mb-4"
              >
                <option value="Available">Available</option>
                <option value="Not Available">Not Available</option>
              </select>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={handleEditFoodItem}
                  className="px-4 py-2 bg-cyan-500 text-white rounded"
                >
                  Save
                </button>
                <button
                  onClick={() => setShowEditPopup(false)}
                  className="px-4 py-2 bg-red-500 text-white rounded ml-2"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Popup */}
        {showDeletePopup && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-10">
            <div className="bg-white p-6 rounded-lg w-1/3">
              <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
              <p>Are you sure you want to delete this food item?</p>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={handleDeleteFoodItem}
                  className="px-4 py-2 bg-red-500 text-white rounded"
                >
                  Delete
                </button>
                <button
                  onClick={() => setShowDeletePopup(false)}
                  className="px-4 py-2 bg-gray-500 text-white rounded ml-2"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderFood;
